import Vue from 'vue'
import VueRouter from 'vue-router'
import versionConfig from '../../version.json'

import { versionService } from "@/api/version";
import { Message, MessageBox } from "element-ui";
import { isTauri, isDesktop, isMobileDevice } from '@/config';
import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    // 通配符路由：匹配所有未定义的路径，重定向到登录页
    path: '*',
    redirect: '/ai/login'
  },
  {
    // 当用户访问根路径'/'时，自动跳转到'/ai/login'
    path: '/',
    redirect: '/ai/login'
  },
  {
    path: '/ai/login',
    name: 'HomeLogin',
    component: () => import("@/views/AI/home/Login.vue"),
    meta: { title: '用户登录与注册 · 汇AI智能体平台' }
  },
  {
    // 保留您原来的 /ai 嵌套结构
    path: "/ai",
    // 使用 agent_home 作为布局组件
    component: () => import("@/views/AI/agent_home.vue"),
    children: [
      {
        path: "",
        redirect: "/ai/login"
      },
      {
        path: "agent",
        name: "Agent",
        meta: { title: "智能体", keepAlive: false },
        component: () => import("@/views/AI/agent/agent.vue"),
      },
      {
        path: "digital",
        name: "Digital",
        meta: { title: "数字人", keepAlive: false },
        component: () => import("@/views/AI/digital/digital.vue"),
      },
      {
        path: "notary",
        name: "Notary",
        meta: { title: "公证员", keepAlive: false },
        component: () => import("@/views/AI/notary/notary.vue"),
      },
      {
        path: "create_digital",
        name: "CreateDigital",
        meta: { title: "创建数字人", keepAlive: false },
        component: () => import("@/views/AI/digital/create_digital.vue"),
      },
      {
        path: 'edit_digital/:id',
        name: 'EditDigital',
        component: () => import('@/views/AI/digital/edit_digital.vue'),
        meta: { title: '编辑数字人', keepAlive: false }
      },
      {
        path: 'edit_notary/:id',
        name: 'EditNotary',
        component: () => import('@/views/AI/notary/edit_notary.vue'),
        meta: { title: '编辑公证员', keepAlive: false }
      },
      {
        path: 'digital/:id',
        name: 'DigitalChat',
        component: () => import('@/views/AI/digital/dchat.vue'),
        meta: { title: '数字人聊天', keepAlive: false }
      },
      {
        path: 'mobile_notice',
        name: 'MobileNotice',
        component: () => import('@/views/AI/digital/mobile_notice.vue'),
        meta: { title: 'PC端使用提示', keepAlive: false }
      },
      {
        path: 'add_digital',
        name: 'AddDigital',
        component: () => import('@/views/AI/digital/add_digital.vue'),
        meta: { title: '创建数字人', keepAlive: false }
      },
      {
        path: 'add_notary',
        name: 'AddNotary',
        component: () => import('@/views/AI/notary/add_notary.vue'),
        meta: { title: '创建公证员', keepAlive: false }
      },
      {
        path: 'mchat/:botId?',
        name: 'MobileChat',
        component: () => import('@/views/AI/digital/mchat_notary.vue'),
        meta: { title: 'AI助手', keepAlive: false }
      },
      {
        path: 'tech_chat/:botId?',
        name: 'TechChat',
        component: () => import('@/views/AI/chat/zchat.vue'),
        meta: { title: 'AI智能体', keepAlive: false }
      },
      {
        path: 'notary_chat/:botId?',
        name: 'MobileNotaryChat',
        component: () => import('@/views/AI/notary/notary_mobile.vue'),
        meta: { title: 'AI公证助手', keepAlive: false }
      },
      // {
      //   path: 'model_training',
      //   name: 'model_training',
      //   component: () => import('@/views/AI/training/model_training.vue'),
      //   meta: {
      //     title: '模型训练' ,
      //     icon: "el-icon-s-home",
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'data_management',
      //   name: 'data_management',
      //   component: () => import('@/views/AI/training/data_management.vue'),
      //   meta: {
      //     title: '数据管理' ,
      //     icon: "el-icon-s-home",
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'model_tuning',
      //   name: 'model_tuning',
      //   component: () => import('@/views/AI/training/model_tuning.vue'),
      //   meta: {
      //     title: '模型调优' ,
      //     icon: "el-icon-s-home",
      //     keepAlive: true
      //   }
      // },
      // {
      //   path: 'model_deployment',
      //   name: 'model_deployment',
      //   component: () => import('@/views/AI/training/model_deployment.vue'),
      //   meta: {
      //     title: '模型部署' ,
      //     icon: "el-icon-s-home",
      //     keepAlive: true
      //   }
      // },
      {
        path: 'training_center',
        name: 'TrainingCenter',
        component: () => import('@/views/AI/training/training_center.vue'),
        meta: { title: 'AI训练中心', keepAlive: false }
      },
      {
        path: 'training_center/report',
        name: 'TrainingReport',
        component: () => import(/* webpackPrefetch: true */ '@/views/AI/training/TrainingReport.vue'),
        meta: { title: 'AI训练中心 - 效果报告', keepAlive: false }
      },
      {
        path: "create_agent",
        name: "CreateAgent",
        meta: { title: "创建智能体", keepAlive: false },
        component: () => import("@/views/AI/agent/create_agent.vue"),
      },
      {
        path: 'edit_agent/:id',
        name: 'EditAgent',
        component: () => import('@/views/AI/agent/edit_agent.vue'),
        meta: { title: '编辑智能体', keepAlive: false }
      },
      {
        path: 'agent/voicemg',
        name: 'VoiceMg',
        component: () => import('@/views/AI/agent/voicemg.vue'),
        meta: { title: '用户之声', keepAlive: false }
      },
      {
        path: 'knowledge',
        name: 'Knowledge',
        component: () => import(/* webpackPrefetch: true */ '@/views/AI/knowledge/knowledge.vue'),
        meta: { title: '知识库', keepAlive: false }
      },
      {
        path: 'create_knowledge',
        name: 'CreateKnowledge',
        component: () => import('@/views/AI/knowledge/create_knowledge.vue'),
        meta: { title: '创建知识库', keepAlive: false }
      },
      {
        path: 'knowledge/:id',
        name: 'KnowledgeDetail',
        component: () => import('@/views/AI/knowledge/knowledge_detail.vue'),
        meta: { title: '知识库详情', keepAlive: false }
      },
      {
        path: 'preview-modal',
        name: 'PreviewModalPage',
        component: () => import('@/views/AI/knowledge/previewModalPage.vue'),
        meta: { title: '原文预览', keepAlive: false }
      },
      {
        path: 'chat/:id',
        name: 'Chat',
        component: () => import('@/views/AI/chat/chat.vue'),
        meta: { title: '智能体聊天', keepAlive: false }
      },
      {
        path: 'note/:id',
        name: 'Note',
        component: () => import('@/views/AI/note/note.vue'),
        meta: { title: '标注', keepAlive: false }
      },
      {
        path: 'json-manager',
        name: 'JsonManager',
        component: () => import('@/components/JsonFileManager.vue'),
        meta: { title: 'JSON文件管理', keepAlive: false }
      },
      {
        path: 'model_management',
        name: 'ModelManagement',
        component: () => import('@/views/AI/training/model_management.vue'),
        meta: { title: '大模型管理', keepAlive: false }
      },
      {
        path: 'model_webmg',
        name: 'ModelWebmg',
        component: () => import('@/views/AI/training/model_webmg.vue'),
        meta: { title: 'Web大模型管理', keepAlive: false }
      },
      {
        path: 'file_library',
        name: 'FileLibrary',
        component: () => import('@/views/AI/library/file_library.vue'),
        meta: { title: '文件库', keepAlive: false }
      },
      {
        path: 'workflow_editor',
        name: 'WorkflowEditor',
        component: () => import('@/views/AI/workflow/workflow_editor.vue'),
        meta: { title: '工作流编排', keepAlive: false }
      }
    ],
  }
]

const router = new VueRouter({
  // 桌面端（Tauri / Electron）用 hash：页面由本地协议或 file 加载，没有服务端兜底
  mode: isDesktop ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  // ★ 桌面端（Tauri / Electron，即 isDesktop）永不进入 Web 登录页
  // 401 / 身份失效时只弹登录弹窗，路由停在当前业务页；冷启动或未知路径直接落首页
  if (isDesktop && to.path === '/ai/login') {
    store.commit('SET_SHOW_LOGIN_WEB_DIALOG', true);
    if (from && from.matched && from.matched.length > 0) {
      // 已经在业务页面里：取消这次导航，把人留在原地
      next(false);
    } else {
      // 首次进入（含 '/'、'*' 的 redirect）或深链：直接去首页，由弹窗承担登录
      // 保留 query（userId / loginInfo / token 等参数由 initializeUser 处理）
      next({ path: '/ai/agent', query: to.query });
    }
    return;
  }
  // 非 Electron 环境才执行版本检测
  if (!isTauri) {
    // 使用versionService来获取版本信息，baseURL已在service内部根据环境配置
    versionService.get("/version.json").then((res) => {
      // 修复：后端返回的属性名是versioin（有拼写错误）而不是version
      let lastVersion = res.version || res.versioin; // 兼容两种拼写方式
      if (localStorage.version == undefined) {
        localStorage.setItem("version", lastVersion);
      } else {
        if (localStorage.version != lastVersion) {
          //localStorage.removeItem("version");
          if (isMobileDevice()) {
            store.commit('SHOW_GLOBAL_CONFIRM', {
              title: '版本更新',
              message: '检测到新版本，请进行更新',
              callback: () => {
                window.location.reload();
                localStorage.setItem("version", lastVersion);
              }
            });
          } else {
            MessageBox.confirm("检测到新版本，请进行更新", {
              confirmButtonText: "更新",
              cancelButtonText: "取消",
              type: "warning",
              showClose: false,
              showCancelButton: true,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              zIndex: 9999,
            }).then(() => {
              window.location.reload();
              localStorage.setItem("version", lastVersion);
            }).catch(() => {
              console.log('暂不更新版本');
            });
          }
        }
      }
    }).catch(error => {
      console.error('版本检测失败:', error);
    });
  }else{
    localStorage.setItem("version", `v${versionConfig.pcVersion}`);
  }
  next();
});

// 全局导航错误兜底：静默处理 Vue Router 可预期的 NavigationFailure
// 避免控制台出现 "Navigation cancelled / redirected / duplicated" 噪声
// 这些错误在多路径并发触发同一跳转时是正常行为（如多个 401 同时触发跳转）
router.onError((err) => {
  const isNavigationFailure =
    err &&
    typeof err === 'object' &&
    ('type' in err ||
      err.name === 'NavigationDuplicated' ||
      err.name === 'NavigationCancelled' ||
      err.name === 'NavigationRedirected' ||
      err.name === 'NavigationAborted');

  if (!isNavigationFailure) {
    // 只上报非预期错误
    console.error('[Router] 未预期的导航错误:', err);
  }
});

export default router;